import { getIconCSSClass } from "../../utils/index";
import BrowserViewGlobal from "../../../Views/BrowserView";
import ActionPointTooltip from "../../ActionPointTooltip";
import useHover from "../../../hooks/useHover";

export default function ExternalLink({
  id,
  iconKind,
  createNonInternalStream,
  linkExternal,
  title,
  tabindex,
  left,
  top,
  linkKind,
  backgroundColor,
}) {
  const [hover, hoverProps] = useHover();

  return (
    <BrowserViewGlobal>
      <a
        id={`action-point-${id}`}
        onClick={() => createNonInternalStream()}
        style={{
          top: `${top}%`,
          left: `${left}%`,
          backgroundColor: `#${backgroundColor}`,
        }}
        className={`view__links__dot ${getIconCSSClass(iconKind, linkKind)}`}
        // title={title}
        href={linkExternal}
        target="_blank"
        tabindex={tabindex}
        {...hoverProps}
      >
        <ActionPointTooltip show={hover} text={title} />
      </a>
    </BrowserViewGlobal>
  );
}
